import { TASK } from "../apiConstant";
import BaseApi from "../baseApi";

class TaskApi extends BaseApi {
  constructor() {
    super();
    this.BASE_URL = process.env.REACT_APP_PROJECT_MANAGEMENT_API_URL || "";
    this.$axiosInstance = this.initAxiosInstance();
  }

  getList(body) {
    return this.post(`${TASK}/list`, body);
  }

  store(body) {
    return this.post(`${TASK}/store`, body);
  }

  deleteTask(body) {
    return this.delete(`${TASK}/delete/${body}`);
  }

  getListMemberProject(body) {
    return this.post(`${TASK}/members-project`, body);
  }

  getListTaskProject(body) {
    return this.post(`${TASK}/list-task-project`, body);
  }

  swap(body) {
    return this.post(`${TASK}/swap`, body);
  }
  commentReply(body) {
    return this.post(`${TASK}/comment`, body);
  }
}
export default TaskApi;
